export default "__VITE_ASSET__C3Rol9UR__"